var React = require('react');

function Printer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m128 32h256v64h-256z","key":0}),React.createElement("path",{"d":"m480 128h-448c-17.6 0-32 14.4-32 32v160c0 17.6 14.397 32 32 32h96v128h256v-128h96c17.6 0 32-14.4 32-32v-160c0-17.6-14.4-32-32-32zm-416 96c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.326 32-32 32zm288 224h-192v-160h192z","key":1})]);
}

Printer.defaultProps = {"height":"512","viewBox":"0 0 512 512","width":"512"};

module.exports = Printer;

Printer.default = Printer;
